'use client';

import Link from 'next/link';
import { useMemo } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Text } from '@eqi-investimentos/react';
import { INVESTOR_PROFILES, WalletInvestmentCategory } from '@/modules/Wallet/interface/walet';
import { PATHS } from '@/config/paths';
import { useGetPrevPositions } from '@/modules/Position/http/client/useGetPrevPositions';
import { useGetSuggestedWallet } from '@/modules/Wallet/http/client/useGetSuggestedWallet';
import { useGetWalletInvestiments } from '@/modules/Wallet/http/client/useGetWalletInvestiments';
import { useGetWalletSummary } from '@/modules/Wallet/http/client/useGetWalletSummary';
import { SemiCircleChart } from '@/components/atoms/SemiCircleChart';
import { InvestBalanceAndProfileCard } from '@/components/molecules/InvestBalanceAndProfileCard';
export const InvestmentsSummaryCard = () => {
  const {
    t
  } = useTranslation('common');
  const {
    data: walletSummary = {
      total: 0,
      checking_account_total: 0,
      investments_total: 0
    },
    isFetching: isFetchingWalletSummary
  } = useGetWalletSummary();
  const {
    data: myInvestiments = {
      categories: []
    },
    isFetching: isFetchingMyInvestiments
  } = useGetWalletInvestiments();
  const isLoading = isFetchingWalletSummary || isFetchingMyInvestiments;
  const {
    data: suggestedWallet = {
      profile_title: ''
    }
  } = useGetSuggestedWallet();
  const {
    data: {
      balance
    } = {
      balance: 0,
      positions: []
    }
  } = useGetPrevPositions();
  const variableIncome = useMemo(() => getVariableIncome(myInvestiments?.categories),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [myInvestiments?.categories]);
  const investorProfilePercentage = getInvestorProfilePercentage(suggestedWallet.profile_title as keyof typeof INVESTOR_PROFILES);
  return <InvestBalanceAndProfileCard isLoading={isLoading} balance={{
    total: walletSummary?.total,
    accounts: [{
      id: crypto.randomUUID(),
      label: 'Saldo em caixa',
      value: walletSummary?.checking_account_total || 0
    }, {
      id: crypto.randomUUID(),
      label: 'Previdência',
      value: balance || null
    }, {
      id: crypto.randomUUID(),
      label: 'Renda Variável',
      value: variableIncome
    }]
  }} footerInfo={{
    title: t('screens.invest.profile.titleProfile'),
    chart: <SemiCircleChart percentage={investorProfilePercentage || 0} label={suggestedWallet.profile_title || <Text as={Link} href={PATHS?.custom?.index} fontSize="xs" fontWeight="light" color="content.primary" textDecoration="underline">
                  {t('attributes.calculate')}
                </Text>} labelProps={{
      fontSize: '0.6875rem'
    }} />
  }} data-sentry-element="InvestBalanceAndProfileCard" data-sentry-component="InvestmentsSummaryCard" data-sentry-source-file="InvestmentsSummaryCard.tsx" />;
};
const getVariableIncome = (data: Omit<WalletInvestmentCategory, 'investments'>[]) => {
  const dataItem = data.find(({
    name
  }) => name.toLowerCase() === 'renda variável');
  return dataItem?.total ?? 0;
};
const getInvestorProfilePercentage = (profile: keyof typeof INVESTOR_PROFILES): number => {
  if (!profile) return 0;
  return INVESTOR_PROFILES[profile];
};